import React from "react";
import { Circle } from "lucide-react";

interface EventLogItemProps {
  time: string;
  event: string;
  type: "success" | "warning" | "error";
}

const EventLogItem: React.FC<EventLogItemProps> = ({ time, event, type }) => {
  const getColorClasses = () => {
    switch (type) {
      case "success":
        return "text-green-600 bg-green-100";
      case "warning":
        return "text-orange-600 bg-orange-100";
      case "error":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  return (
    <div className="flex items-center space-x-2 md:space-x-4 py-2 md:py-3">
      <div className="text-sm text-gray-500 w-20">{time}</div>
      <div
        className={`w-2 h-2 md:w-3 md:h-3 rounded-full flex items-center justify-center ${getColorClasses()}`}
      >
        <Circle className="w-2 h-2 fill-current" />
      </div>
      <div className="flex-1 text-xs md:text-sm text-gray-700">{event}</div>
    </div>
  );
};

export default EventLogItem;
